import { useCallback, useEffect, useState } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useGetAssemblies } from './hooks/useGetAssemblies';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import { useNavbarHeight } from '@/hooks/useNavbarHeight';
import { useInsightsPageParams } from '@/hooks';
import { ReviewScreenHeader } from './ReviewScreenHeader';
import { TabNavigation } from './TabNavigation';
import { useBulkAssemblyData } from './hooks/useBulkAssemblyData';

export const ReviewScreen = () => {
  const [selectedAssemblyId, setSelectedAssemblyId] = useAtom(state.selectedAssemblyId);
  const setSelectedAssemblyName = useSetAtom(state.selectedAssemblyName);
  const setSelectedReviewPoiFilters = useSetAtom(state.selectedReviewPoiFilters);
  const setSelectedReviewPaintRegionIds = useSetAtom(state.selectedReviewPaintRegionIds);
  const setSelectedReviewWorkpackIds = useSetAtom(state.selectedReviewWorkpackIds);
  const setSelectedReviewPoiTypeId = useSetAtom(state.selectedReviewPoiTypeId);
  const setSelectedReviewPoiSearchTerm = useSetAtom(state.reviewPoiSearchTerm);
  const setSelectedReviewPoiTypes = useSetAtom(state.selectedReviewPoiTypes);
  const setIsAllReviewPointsOfInterestSelected = useSetAtom(
    state.isAllReviewPointsOfInterestSelected
  );
  const setSelectedReviewPointsOfInterest = useSetAtom(state.selectedReviewPointsOfInterest);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navbarHeight = useNavbarHeight();
  const { clearAssembly } = useInsightsPageParams();
  useGetAssemblies();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const assemblyIdFromUrl = params.get('selectedAssemblyId');
    const assemblyNameFromUrl = params.get('selectedAssemblyName');
    if (assemblyIdFromUrl && assemblyNameFromUrl) {
      setSelectedAssemblyId(assemblyIdFromUrl);
      setSelectedAssemblyName(assemblyNameFromUrl);
    }
    setSelectedReviewPointsOfInterest([]);
    setIsAllReviewPointsOfInterestSelected(false);
    setSelectedReviewPoiTypeId(undefined);
    setSelectedReviewPoiTypes([]);
  }, [
    setSelectedReviewPointsOfInterest,
    setIsAllReviewPointsOfInterestSelected,
    setSelectedReviewPoiTypeId,
    setSelectedReviewPoiTypes,
    setSelectedAssemblyId,
    setSelectedAssemblyName,
  ]);

  const handleClose = useCallback(() => {
    setDrawerOpen(false);
    setSelectedAssemblyId(undefined);
    setSelectedAssemblyName(undefined);
    setSelectedReviewPoiFilters({});
    setSelectedReviewPaintRegionIds([]);
    setSelectedReviewWorkpackIds([]);
    setSelectedReviewPoiTypeId(undefined);
    setSelectedReviewPoiSearchTerm('');
    setIsAllReviewPointsOfInterestSelected(false);
    setSelectedReviewPointsOfInterest([]);
    setSelectedReviewPoiTypes([]);
    clearAssembly();
  }, [
    setSelectedAssemblyId,
    setSelectedAssemblyName,
    setSelectedReviewPoiFilters,
    setSelectedReviewPaintRegionIds,
    setSelectedReviewWorkpackIds,
    setSelectedReviewPoiTypeId,
    setSelectedReviewPoiSearchTerm,
    setIsAllReviewPointsOfInterestSelected,
    setSelectedReviewPointsOfInterest,
    setSelectedReviewPoiTypes,
    clearAssembly,
  ]);

  useEffect(() => {
    setDrawerOpen(!!selectedAssemblyId);
  }, [selectedAssemblyId]);

  useBulkAssemblyData({ assemblyIds: selectedAssemblyId ? [selectedAssemblyId] : [] });

  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={handleClose}
      PaperProps={{
        sx: { width: '70vw', backgroundColor: '#fff' },
      }}
      transitionDuration={300}
    >
      <Stack
        sx={{ paddingTop: `${navbarHeight}px`, overflowY: 'auto', height: '100%' }}
        id="review-panel"
      >
        {selectedAssemblyId && (
          <>
            <ReviewScreenHeader handleClose={handleClose} />
            <TabNavigation />
          </>
        )}
      </Stack>
    </Drawer>
  );
};
